import * as types from './scenario-types';
import Vue from 'vue';
import ApplicationData from '../../models/ApplicationData';
import MovementProfile from '../../models/MovementProfile';

const scenarios = {
    state: {
        scenarios: [],
        movement_types: [],
        new_scenario: {},
        active_scenario_id: undefined,
        power_supplies: [],
        unit_profiles: [],
        shared: {},
    },
    mutations: {
        [types.SET_ACTIVATE_SCENARIO](state, payload) {
            state.active_scenario_id = payload.id;
        },
        // Start a new scenario
        NEW_SCENARIO(state) {
            state.new_scenario = {
                profiles: [],
                motor: {},
                application_data: {},
            };
            state.active_scenario_id = -1;
        },
        // Set the array of scenarios saved by the user
        [types.FETCH_SCENARIOS](state, { scenarios }) {
            state.scenarios = scenarios;
        },
        SET_MOTOR(state, { motor }) {
            state.new_scenario.motor = motor;
        },
        SET_MOVEMENT_TYPES(state, { types }) {
            state.movement_types = types.sort((a, b) => {
                if (a.order === null || b.order === null) {
                    return 0;
                }

                return a.order - b.order;
            });
        },
        SET_POWER_SUPPLIES(state, { power }) {
            state.power_supplies = power;
        },
        REMOVE_SCENARIO(state, { id }) {
            //TODO get index of scenario and remove it from array.

            for (let i = 0; i < state.scenarios.length; i++) {
                if (state.scenarios[i].id === id) {
                    state.scenarios.splice(i, 1);
                }
            }
        },
        SET_UNIT_PROFILES(state, { profiles }) {
            state.unit_profiles = profiles;

            ApplicationData.unitProfiles = profiles;
            MovementProfile.unitProfiles = profiles;
        },
        PUSH_SCENARIO(state, { scenario }) {
            let s = state.scenarios.find(s => s.id === scenario.id);

            if (s === undefined) {
                state.scenarios.push(scenario);
            } else {
                let index = state.scenarios.indexOf(s);

                if (index > -1) {
                    state.scenarios[index] = scenario;
                }
            }
        },
        UPDATE_SCENARIO(state, { scenario }) {
            let s = state.scenarios.find(s => s.id === scenario.id);

            if (s !== undefined) {
                let index = state.scenarios.indexOf(s);
                if (index > -1) {
                    state.scenarios[index] = scenario;
                }
            }
        },
        SET_SHARED_SIMULATION(state, { scenario }) {
            state.shared = scenario;
        },
    },
    actions: {
        activateScenario(context, id) {
            context.commit(types.SET_ACTIVATE_SCENARIO, {
                id,
            });
        },
        deactivateScenario(context) {
            context.commit(types.SET_ACTIVATE_SCENARIO, {
                id: undefined,
            });
        },
        newScenario(context) {
            context.commit('NEW_SCENARIO');
        },
        fetchSavedScenarios(context) {
            let req = Vue.api.get('/simulations/');
            req.send()
                .then(scenarios => {
                    scenarios = scenarios.filter(item => {
                        return item.name !== null;
                    });

                    context.commit(types.FETCH_SCENARIOS, {
                        scenarios,
                    });
                })
                .catch(err => {
                    console.warn('ERR', err);
                });
        },
        setSelectedMotor(context, motor) {
            context.commit('SET_MOTOR', { motor });
        },
        setMovementTypes(context, types) {
            context.commit('SET_MOVEMENT_TYPES', { types });
        },
        setPowerSupplies(context, power) {
            context.commit('SET_POWER_SUPPLIES', { power });
        },
        removeScenario(context, scenarioId) {
            let req = Vue.api.delete('/simulations/' + scenarioId + '/');
            req.send()
                .then(result => {
                    context.commit('REMOVE_SCENARIO', { id: scenarioId });
                })
                .catch(err => {
                    console.warn('DELETE SCENARIO ERR', err);
                });
        },
        getUnitProfiles(context) {
            let req = Vue.api.get('/unit_profiles/');
            req.send()
                .then(result => {
                    localStorage.setItem('unit_profiles', JSON.stringify(result));
                    context.commit('SET_UNIT_PROFILES', { profiles: result });
                })
                .catch(err => {
                    console.warn('Set unit profiles error', err);
                });
        },
        getUnitProfilesFromLocalStorage(context) {
            let stored = localStorage.getItem('unit_profiles');
            if (stored !== undefined && stored !== null) {
                context.commit('SET_UNIT_PROFILES', { profiles: JSON.parse(stored) });
            }
        },
        saveScenario(context, scenario) {
            if (scenario !== undefined) {
                context.commit('PUSH_SCENARIO', { scenario });
            }
        },
        updateScenario(context, scenario) {
            if (scenario !== undefined) {
                context.commit('UPDATE_SCENARIO', { scenario });
            }
        },
        getSharedScenario(context, token) {
            let req = Vue.api.get('/share_simulation?share_token=' + token);
            req.send()
                .then(result => {
                    context.commit('SET_SHARED_SIMULATION', { scenario: result });
                })
                .catch(err => {
                    localStorage.removeItem('share_token');
                    context.commit('SET_SHARED_SIMULATION', { scenario: undefined });
                });
        },
    },
    getters: {
        getMovementTypes(state) {
            return state.movement_types;
        },
        getScenario: (state, getters) => id => {
            let s = state.scenarios.find(scenario => scenario.id === id);
            return s;
        },
        getScenarios(state) {
            return state.scenarios;
        },
        getActiveScenario(state, getters) {
            if (state.active_scenario_id === undefined) {
                return undefined;
            }

            let scenario = getters.getScenario(state.active_scenario_id);
            if (scenario !== undefined) {
                return scenario;
            } else if (Object.keys(state.shared).length > 0) {
                return state.shared;
            } else {
                return undefined;
            }
        },
        getActiveScenarioId(state) {
            return state.active_scenario_id;
        },
        getNewScenario(state) {
            return state.new_scenario;
        },
    },
};

export default scenarios;
